import React from "react";

type Props = {
  checked?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  disabled?: boolean;
  size?: "sm" | "md";
};
const ToggleButton = (props: Props) => {
  const isSm = props.size === "sm";
  return (
    <label className="flex cursor-pointer select-none items-center">
      <div className="relative">
        <input
          type="checkbox"
          checked={props.checked}
          onChange={props.onChange}
          disabled={props.disabled}
          className="sr-only"
        />
        <div
          className={`box block rounded-full transition-colors ${
            isSm ? "h-5 w-9" : "h-6 w-11"
          } ${
            props.checked ? "bg-[#65C466]" : "bg-[#E9E9EA]"
          }`}
        ></div>
        <div
          className={`absolute left-0.5 top-0.5 flex items-center justify-center rounded-full bg-white transition-transform ${
            isSm ? "h-4 w-4" : "h-5 w-5"
          } ${
            props.checked ? (isSm ? "translate-x-4" : "translate-x-5") : ""
          }`}
        ></div>
      </div>
    </label>
  );
};

export default ToggleButton;
